import { useEffect, useRef } from "react";

export default function useVisiblePoll(task, intervalMs, enabled) {
  const taskRef = useRef(task);
  taskRef.current = task;

  useEffect(() => {
    if (!enabled) return undefined;

    let timer = null;

    const run = () => {
      Promise.resolve()
        .then(() => taskRef.current())
        .catch(() => {
          // A background refresh must never surface an error to the rider.
        });
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      if (!timer) timer = setInterval(run, intervalMs);
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        stop();
        return;
      }
      run();
      start();
    };

    if (document.visibilityState !== "hidden") start();
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [enabled, intervalMs]);
}
